import { requestFactory } from './index';
const request = requestFactory('/api/ipt');
export var BandwidthClusterInternetChargeType;
(function (BandwidthClusterInternetChargeType) {
    BandwidthClusterInternetChargeType["DayPeakBandwidth"] = "DayPeakBandwidth";
    BandwidthClusterInternetChargeType["MonthlyPercent95Bandwidth"] = "MonthlyPercent95Bandwidth";
})(BandwidthClusterInternetChargeType || (BandwidthClusterInternetChargeType = {}));
export function getLookUpBandwidthCluster(params) {
    return request({
        method: 'get',
        url: '/cluster/lookupBandwidthCluster',
        params,
    });
}
